export default function preloaderHallway (scene) {

	const levels = ['chase-me', 'good-night', 'fly-high', 'you-and-i', 'what', 'piri', 'deja-vu', 'scream', 'boca', 'odd-eye', 'because', 'maison'];

    scene.load.image(`tileshallway-3`, `/tiles/hallway-3.png`);
    scene.load.image(`dialog-1`, `/img/hallway/dialogs/dialog-1.png`);

	scene.load.audio("footsteps", ["/audio/footsteps-3.mp3"]);
	scene.load.audio("fullmoonSong", ["/audio/songs/fullmoon.mp3"]);
	scene.load.audio("bonvoyageSong", ["/audio/songs/bonvoyage.mp3"]);
	scene.load.audio("justiceSong", ["/audio/songs/justice.mp3"]);
	scene.load.audio("maydaySong", ["/audio/songs/mayday.mp3"]);
	scene.load.audio("ootdSong", ["/audio/songs/ootd.mp3"]);
	scene.load.audio("risingSong", ["/audio/songs/rising.mp3"]);
	scene.load.audio("visionSong", ["/audio/songs/vision.mp3"]);

	for (const level of levels) {
		scene.load.spritesheet(`door-${level}`,
			`/img/hallway/door-1.png`,
			{ frameWidth: 36, frameHeight: 54 }
		);
	}

	scene.load.spritesheet(`door-reason`,
			`/img/hallway/door-final-2.png`,
			{ frameWidth: 36, frameHeight: 54 }
		);

	scene.load.spritesheet(`door-block`,
		`/img/hallway/block-door.png`,
		{ frameWidth: 34, frameHeight: 54 }
	);

	scene.load.tilemapTiledJSON(`hallway-3`, `/tiles/hallway-3.tmj`);

}